import React from 'react';
import './DashboardTaskbarBody.css';
import DashboardTaskbarBodyTab from "../DashboardBodyTabs/DashboardTaskbarBodytTabs";
import descriptionDetails from './DashboardDescription'

const DasboardTaskbarBrandingBody = () => {
    return (
        <div className="dashboardtaskbarbody">
            {/* <DashboardTaskbarBodyTab header="Brand Essence" body={descriptionDetails.Brand_essence} /> */}
            {/* <DashboardTaskbarBodyTab header="Landing Pages" body={descriptionDetails.Landing_pages} /> */}
            {/* <DashboardTaskbarBodyTab header="SEO Metatag" body={descriptionDetails.SEO_Metatag} /> */}
            {/* <DashboardTaskbarBodyTab header="Taglines" body={descriptionDetails.Ad_Headline} /> */}
            {/* <DashboardTaskbarBodyTab header="Unique Value Preposition" body={descriptionDetails.Unique_value_proposition} /> */}
        </div>
    )
}

export default DasboardTaskbarBrandingBody;